import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Text, Format } from 'src/Components'

const getMessage = appreciationPercent => {
  const percent = Format.percentage(Math.abs(appreciationPercent))

  if (appreciationPercent > 10) {
    return (
      <FormattedMessage
        id='Homeowner.estimatedValue.appreciatedOverTenPercent'
        defaultMessage="That's up {percent} from when you bought it. Nice!"
        values={{ percent }}
      />
    )
  }

  if (appreciationPercent > 0) {
    return (
      <FormattedMessage
        id='Homeowner.estimatedValue.appreciatedOverZeroPercent'
        defaultMessage="That's up {percent} from when you bought it."
        values={{ percent }}
      />
    )
  }

  if (appreciationPercent < 0) {
    return (
      <FormattedMessage
        id='Homeowner.estimatedValue.depreciatedOverZeroPercent'
        defaultMessage='Down {percent} from when you bought it.'
        values={{ percent }}
      />
    )
  }

  return null
}

const AppreciationSentence = ({ appreciationPercent, className }) => {
  const message = getMessage(appreciationPercent)

  if (!message) {
    return null
  }

  return (
    <Text color='quiet' align='center' paragraph className={className}>
      {message}
    </Text>
  )
}

export default AppreciationSentence
